import { Location } from '../../components/NewSearch/NewSearchLocations/types';

export const getChosenLocationNames = (
  locations: Location[],
  chosenLocationIds: string[]
): string[] => {
  const idSet = new Set((chosenLocationIds || []).map(String));

  return locations.reduce<string[]>(
    (result, { id, name }) =>
      idSet.has(String(id)) ? [...result, (name ?? '').trim()] : result,
    []
  );
};
